<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>线下入库</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="票据类型">
            <el-select
              size="small"
              v-model="formInline.type"
              placeholder="请选择"
            >
              <el-option
                v-for="type in ticketType"
                :label="type.key"
                :value="type.value"
                :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入库日期">
            <el-date-picker
              style="width: 190px !important"
              size="small"
              v-model="formInline.createDate"
              type="date"
              value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库日期">
            <el-date-picker
              style="width: 190px !important"
              size="small"
              v-model="formInline.outDate"
              type="date"
              value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="期限类型">
            <el-select
              size="small"
              v-model="formInline.termType"
              placeholder="请选择"
            >
              <el-option
                v-for="type in expiresType"
                :label="type.key"
                :value="type.value"
                :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <el-input
              size="small"
              clearable
              v-model="formInline.customerName"
              placeholder="客户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="票据号码">
            <el-input
              size="small"
              clearable
              v-model="formInline.moneyOrderCode"
              placeholder="票据号码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所在户">
            <el-select
                size="small"
                v-model="formInline.account"
                placeholder="请选择"
            >
              <el-option
                  v-for="type in addTableData"
                  :label="type.value"
                  :value="type.key"
                  :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="票面金额">
            <el-input
                size="small"
                clearable
                v-model="formInline.faceValue"
                placeholder="票面金额"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="承兑人">
            <el-input
                size="small"
                clearable
                v-model="formInline.acceptorName"
                placeholder="承兑人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              v-hasPerm="btn_perm_type.offline.add"
              @click="handleAdd"
              >新增</el-button
            >
            <el-button
              size="small"
              icon="el-icon-s-claim"
              v-hasPerm="btn_perm_type.offline.update"
              @click="handleBatchStoreTicket"
              >批量编辑</el-button
            >
            <el-button
              size="small"
              icon="el-icon-delete-solid"
              v-hasPerm="btn_perm_type.offline.delete"
              @click="handleBatchDeleteTicket"
              >批量删除</el-button
            >
            <el-button
              size="small"
              v-hasPerm="btn_perm_type.offline.export"
              @click="handleExport"
              icon="el-icon-top-right"
              >导出</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      style="
        width: 100%;
        text-align: right;
        margin-bottom: 10px;
        height: 50px;
        line-height: 50px;
        float: left;
      "
    >
      <span style="margin-right: 15px">
        总张数（张）<span style="font-weight: bold">{{ faceCount }}</span>
      </span>
      <span style="margin-right: 15px">
        票面价值（万）<span style="font-weight: bold">{{ allInValue }}</span>
      </span>
      <span style="margin-right: 15px">
        票据金额（万）<span style="font-weight: bold">{{ faceAllValue }}</span>
      </span>
      <span>
        差值（万）<span style="font-weight: bold">{{
          allInDifferencePrice
        }}</span>
      </span>
    </div>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      :cell-style="handleCellStyle"
      @select="handleSelect"
      @select-all="handleSelect"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.offline.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.offline.view"
            type="success"
            @click="handleEdit(scope.row, true)"
            >详情</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.offline.view"
            type="success"
            @click="handleBatchBackTicket(scope.row)"
            >调整</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.offline.delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="moneyOrderCode"
        width="120px"
        label="票据号码"
      >
        <template slot-scope="props">
<!--          <el-tooltip-->
<!--            effect="dark"-->
<!--            :content="props.row.moneyOrderCode"-->
<!--            placement="top-start"-->
<!--          >-->
            <span
              >......<span>{{ props.row.moneyOrderCode.slice(-9) }}</span></span
            >
<!--          </el-tooltip>-->
        </template>
      </el-table-column>
       <el-table-column
        sortable
        prop="cusTypeName"
        label="客户类型"
        width="100px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="acceptorName"
        label="承兑人"
        width="140px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="faceValue"
        label="票面金额（万）"
        show-overflow-tooltip
        width="120"
        align="center"
      >
        <template slot-scope="props">
          {{
            props.row.outMoneyOrderStatus == 2 
            ? props.row.outCount > 1 ? `${props.row.faceValue} * ${props.row.outCount}张` : props.row.faceValue 
            : props.row.allCount > 1 ? `${props.row.faceValue} * ${props.row.allCount}张` : props.row.faceValue  
          }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="createDate"
        label="入库日期"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="issueDate"
        label="开票日期"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="dueDate"
        label="到期日期"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="termType"
        label="期限类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="flaw"
        label="瑕疵情况"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inSalesman"
        label="业务员"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inPercentage"
        label="进价（%）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inStatus"
        label="入库状态"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inBidder"
        label="报价员"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inOffer"
        label="报价成本（%）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="inArrears"
        label="入库应收（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="outArrears"
        label="入库应付"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :edit-form="editForm"
      @confirm="handleEditForm"
    ></EditForm>
    <EditFormDetail
      title="票据入库"
      :visible.sync="editFormDetailVisible"
      :edit-form="editForm"
    ></EditFormDetail>
    <EditPatch
      title="批量编辑"
      :data="editData"
      :visible.sync="batchVisible"
      @confirm="handleBatchEditFormConfirm"
    ></EditPatch>
    <BatchBackPatch
      title="调整"
      :visible.sync="batchVisibleBack"
      :edit-form="editForm"
      @confirm="handleEditForm"
    ></BatchBackPatch>
    <AddTicket
      title="手动入库"
      :visible.sync="addFormVisible"
      @confirm="handleAddTicketConfirm"
      type="offlineStore"
    ></AddTicket>
  </div>
</template>

<script>
import {
  offlineStoreForTick,
  offlineUpdateStoreForTick,
  offlineDeleteBatchTicket,
  exportCheck,
  delTicket,
  delBatchTicket,
} from "@/api/ticket/ticket";
import Pagination from "@/components/pagination";
import EditForm from "./add-edit";
import AddTicket from "@/views/ticket/ticket-capture/add-edit";
import EditFormDetail from "./add-edit/detail";
import EditPatch from "./batch";
import BatchBackPatch from "./add-edit/back";
import { formatMoney, timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      editFormVisible: false,
      editFormDetailVisible: false,
      title: "",
      addTableData:[
      {"key":"a","value":"    A"},
        {"key":"b","value":"    B"},
        {"key":"c","value":"    C"},
        {"key":"d","value":"    D"},
        {"key":"e","value":"    E"},
        {"key":"f","value":"    F"},
        {"key":"g","value":"    G"},
        {"key":"h","value":"    H"},
      ],
      statusType: [
        { key: "全部", value: "" },
        { key: "待入库", value: "待入库" },
        { key: "正常", value: "正常" },
        { key: "已预订", value: "已预订" },
      ],
      expiresType: [
        { key: "全部", value: "" },
        { key: "不足月", value: "不足月" },
        { key: "半年期", value: "半年期" },
        { key: "一年期", value: "一年期" },
        { key: "超期", value: "超期" },
      ],
      ticketType: [
        { key: "全部", value: "" },
        { key: "电银", value: "电银" },
        { key: "电商", value: "电商" },
        { key: "纸票", value: "纸票" },
      ],
      editForm: {},
      formInline: {},
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      batchVisible: false,
      batchVisibleBack: false,
      selectRows: [],
      faceCount: 0,
      allInValue: 0,
      faceAllValue: 0,
      allInDifferencePrice: 0,
      editData: [],
      isSame: true,
      addFormVisible: false,
    };
  },
  components: {
    Pagination,
    EditForm,
    EditFormDetail,
    EditPatch,
    BatchBackPatch,
    AddTicket,
  },
  created() {
    this.getData();
  },
  methods: {
    handleCellStyle({ row, column, rowIndex, columnIndex }) {
      if (
          [
            "acceptorName",
            "moneyOrderCode",
          ].includes(column.property)
      ) {
        if(row.moneyOrderCode.indexOf("-") > -1){
          return { background: "#BBBB44" };
        }else{
          return null;
        }
      }
      return null;
    },
    handleAdd() {
      this.addFormVisible = true;
    },
    handleAddTicketConfirm() {
      this.getData();
    },
    handleSelectionChange(selection) {
      for (let select of selection) {
        this.isSame = this.selectRows.every(
          (sel) => sel.customerName === select.customerName
        );
        if (!this.isSame) {
          this.$message.warning("请选择同一客户的数据");
          break;
        }
      }
    },
    handleBatchEditFormConfirm() {
      this.getData();
    },
    handleBatchEditBackConfirm() {
      this.getData();
    },
    handleSelect(selection, row) {
      this.selectRows = selection;
    },
    handleBatchBackTicket(row) {
      this.editForm = row;
      this.batchVisibleBack = true;
        
    },
    handleBatchStoreTicket() {
      if (!this.isSame) {
        this.$message.warning("选中的数据中包含不同的客户");
        return;
      }
      if (this.selectRows.length) {
        this.editData = this.selectRows;
        this.batchVisible = true;
      } else {
        this.$message.warning("未选中数据，无法操作！");
      }
    },
    handleBatchDeleteTicket(rows) {
      if (this.selectRows.length) {
        this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          offlineDeleteBatchTicket(
              this.selectRows.map((item) => {
                return item.id;
              })
          ).then(() => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.getData();
          }).catch(() => {
            this.$message.error("数据删除失败，请稍后再试！");
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
      } else {
        this.$message.warning("未选中数据，无法操作！");
      }

    },
    handleExport() {
      window.location.href="/manager/moneyOrder/exportStock/1?date="+this.formInline.createDate;
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    handleFormatMoney(row, column, cellValue) {
      if (cellValue) {
        return formatMoney(cellValue);
      }

      return cellValue;
    },
    getData() {
      this.selectRows = [];
      this.loading = true;
      offlineStoreForTick(
        this.pager.currentPage,
        this.pager.pageSize,
        this.formInline
      )
        .then(
          ({
            faceCount,
            allInValue,
            faceAllValue,
            allInDifferencePrice,
            pages,
          }) => {
            const { content, page, size, totalCount } = pages;
            // 总张数 faceCount
            this.faceCount = faceCount;
            // 票面价值 allInValue
            this.allInValue = allInValue;
            // 票据金额 faceAllValue
            this.faceAllValue = faceAllValue;
            // 差值 allInDifferencePrice
            this.allInDifferencePrice = allInDifferencePrice;

            this.userData = content;
            this.pager.currentPage = page;
            this.pager.pageSize = size;
            this.pager.total = totalCount;
          }
        )
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {};
      this.getData();
    },
    handleEdit(row, readonly) {
      if (row) {
        this.title = "入库待记账";
        this.editForm = row;
      } else {
        this.title = "添加入库";
        this.editForm = {};
      }

      if (readonly) {
        this.editFormDetailVisible = true;
      } else {
        this.editFormVisible = true;
      }
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delTicket(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
}
.el-input {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/ticket-offline/index.vue